
export const ELEM_ID_WIDGET = "widget_root";
export const CLASS_WIDGET = "infw-root";

export const SUCCESS_CODE = 0;
export const PARTIAL_SUCCESS_CODE = 60210;

export const SUCCESSFUL_FIRST_LOAD_EVENT = 'event51';
export const SUCCESSFUL_COMPLETED_JOURNEY_EVENT = 'event14';

export const DTM = 'DTM';
export const ITAG = 'ITAG';
export const ONE_AMEX_DDL = 'ONE_AMEX_DDL';
export const ONE_APP_DDL_TRACKING = 'ONE_APP_DDL_TRACKING';


// WEBPACK FOOTER //
// ./application/src/models/consts.js